var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('NavigationBar'),_c('button',{staticStyle:{"width":"100px","height":"100px","border":"1px solid #000"},on:{"click":_vm.goSet}},[_vm._v(" goSet ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }